/**
 * Trend glyph for stat tiles and table rows: de-emphasis grey, the latest
 * point in the data hue. Decorative — the number beside it carries the value.
 */
export function Sparkline({ values, label, width = 88, height = 24 }: { values: number[]; label: string; width?: number; height?: number }) {
  const max = Math.max(...values, 1);
  const step = width / Math.max(values.length - 1, 1);
  const y = (value: number) => height - 3 - (value / max) * (height - 6);
  const points = values.map((value, i) => `${(i * step).toFixed(1)},${y(value).toFixed(1)}`).join(" ");
  const last = values.length - 1;
  return (
    <svg width={width} height={height} viewBox={`-3 0 ${width + 6} ${height}`} role="img" aria-label={label} style={{ flex: "none", overflow: "visible" }}>
      <polyline points={points} fill="none" stroke="var(--spark)" strokeWidth={1.5} strokeLinejoin="round" strokeLinecap="round" />
      <circle cx={last * step} cy={y(values[last]!)} r={3} fill="var(--series-1)" stroke="var(--surface)" strokeWidth={1.5} />
    </svg>
  );
}
